define((require) => {
    "use strict";

    const Marionette    = require("marionette");
    const {capitalize}  = require("shared/util/StringUtils");
    const {isFunction}  = require("underscore");

    /**
     * A <tt>ViewController</tt> acts as a mediator/controller for a specific
     * view (only <tt>ImprovedView</tt>'s for now) and is responsible for dealing with any related
     * business/application logic, making the actual view as "clean" as possible.
     *
     * @see  ImprovedView
     * @see  SignInView (for implementation example)
     *
     * @class ViewController
     * @author Kim
     */
    return Marionette.Controller.extend({

        view: null,

        options: null,

        model: null,

        ui: null,

        /**
         * Delegate all events emitted directly on the view to the controller
         * as function calls with an "onView"-prefix.
         *
         * ":"'s are removed, and the following word capitalized.
         *
         * Also makes sure `close` the controller is closed when the view is.
         *
         * "toggleComments" -> onViewToggleComments()
         * "quickView:open" -> onViewQuickViewOpen()
         *
         * @private
         */
        _setupViewEvents() {
            // Close controller when view is closed.
            this.listenToOnce(this.view, "close", () => {
                this.close();
            });

            this.listenToOnce(this.view, "item:rendered", this._itemRenderedHandler);

            // Delegate events triggered on the view to the controller as
            // function calls.
            this.listenTo(this.view, "all", (eventType, ...args) => {
                const fnName = `onView${eventType.split(":").map(capitalize).join("")}`;
                const listenerFunction = this[fnName];

                if (isFunction(listenerFunction)) {
                    listenerFunction.apply(this, args);
                }
            });
        },

        _itemRenderedHandler() {
            // Store a feference to the view's ui object
            this.ui = this.view.ui;
            // Make sure to clear listeners in case the view was re-rendered
            this.stopListening(this.view);
            // Hook up custom events
            this._setupViewEvents();
            // Invoke onRender callback
            this.onViewRender();
        },

        initialize() {
            this.view = this.options.view;
            this.options = this.view.options;
            this.model = this.view.model;

            this.listenToOnce(this.view, "item:rendered", this._itemRenderedHandler);

            this.onInitialize();
        },

        /**
         * Invoked (only once) as part of the initialize cycle.
         */
        onInitialize() {

        },

        /**
         * Syncs with the views rendering cycle, invoked when the view is rendered. Similar to
         * the view's #onRender.
         */
        onViewRender() {

        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/util/ViewController.js